import { render, staticRenderFns } from "./payroll.vue?vue&type=template&id=55ed128b&scoped=true"
import script from "./payroll.vue?vue&type=script&lang=js"
export * from "./payroll.vue?vue&type=script&lang=js"
import style0 from "./payroll.vue?vue&type=style&index=0&id=55ed128b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ed128b",
  null
  
)

export default component.exports